import { render, staticRenderFns } from "./Redeem.vue?vue&type=template&id=149d1012&scoped=true"
import script from "./Redeem.vue?vue&type=script&lang=js"
export * from "./Redeem.vue?vue&type=script&lang=js"
import style0 from "./Redeem.vue?vue&type=style&index=0&id=149d1012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149d1012",
  null
  
)

export default component.exports